// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"526":"b79339a51ae718128645","888":"cfb59a315d788b5f543b"}[chunkId] + ".css";
};